module.exports = __webpack_public_path__ + "img/MyInsights_Studio_white.67ebdefb.png";